// extracted by mini-css-extract-plugin
module.exports = {"image":"modal_image__jDZNl","head":"modal_head__KWVLB","cta":"modal_cta__HSS64"};